export abstract class ModelBase {
    constructor(init?: Partial<ModelBase>) {
        Object.assign(this, init);
    }
}